import { env } from '@/env';
import { type FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';

let app: FirebaseApp | undefined;
let auth: Auth | undefined;

export const getFirebaseApp = (): FirebaseApp => {
  if (app) return app;
  const existing = getApps()[0];
  if (existing) {
    app = existing;
    return app;
  }
  app = initializeApp({
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  });
  return app;
};

export const getFirebaseAuth = (): Auth => {
  if (auth) return auth;
  auth = getAuth(getFirebaseApp());
  return auth;
};
